// src/components/auth/Register.jsx - Updated with immediate dashboard access
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './auth.css';
import logo from '../../assets/logo3.png';
import axios from 'axios';

const Register = ({ setIsAuthenticated, setUser }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        company: '',
        phone: '',
        agreeToTerms: false
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
const [registeredEmail, setRegisteredEmail] = useState(''); 
    // ✅ FIXED: Use environment variable instead of hardcoded URL
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

    // Check for selected package from services
    useEffect(() => {
        const packageFromSession = sessionStorage.getItem('selectedPackage');
        const packageFromState = location.state?.selectedPackage;
        
        if (packageFromSession) {
            const pkg = JSON.parse(packageFromSession);
            setSelectedPackage(pkg);
        } else if (packageFromState) {
            setSelectedPackage(packageFromState);
        }
    }, [location]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Validation
        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        if (formData.password.length < 8) {
            setError('Password must be at least 8 characters');
            return;
        }

        if (!formData.agreeToTerms) {
            setError('Please agree to terms and conditions');
            return;
        }

        setLoading(true);

        try {
            // ✅ FIXED: Use API_URL variable
            const response = await axios.post(`${API_URL}/api/auth/register`, {
                email: formData.email,
                password: formData.password,
                firstName: formData.firstName,
                lastName: formData.lastName,
                company: formData.company || '',
                phone: formData.phone || '',
                selectedPackage: selectedPackage
            });

           
            if (response.data.success) {
                // Do NOT store a token or log the user in.
                // Access is granted only after they verify via email.
                setShowSuccess(true);
                setLoading(false);
                setRegisteredEmail(formData.email); // add this to component state
            } else {
                setError(response.data.error || 'Registration failed');
                setLoading(false);
            }

        } catch (err) {
            console.error('Registration error:', err);
            setError(err.response?.data?.error || 'Network error. Please check if backend is running.');
            setLoading(false);
        }
    };

    // Test backend connection (keep for debugging)
    const testBackend = async () => {
        try {
            const response = await fetch(`${API_URL}/api/health`);
            const data = await response.json();
            console.log('Backend health check:', data);
            alert(`Backend is ${data.status}`);
        } catch (error) {
            console.error('Backend not reachable:', error);
            alert('Backend is not running or not reachable');
        }
    };

    // Show success message overlay
   if (showSuccess) {
        return (
            <div className="auth__page">
                <div className="auth__success-overlay">
                    <div className="auth__success-card">
                        <div className="success-animation">
                            <i className="bx bx-envelope"></i>
                        </div>
                        <h2>Check your email</h2>
                        <p>We sent a verification link to <strong>{registeredEmail}</strong>.</p>
                        <p className="success-subtitle">
                            Click the link to activate your account, then sign in.
                        </p>
                        <Link to="/login" className="button button--flex" style={{ marginTop: '1.5rem' }}>
                            Go to Login
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth__page">
            <div className="auth__container auth__container--register">
                {/* Form Side */}
                <div className="auth__box">
                    {/* Back to Home — animated pill, on the form */}
                    <Link to="/" className="auth__back-btn">
                        <i className="bx bx-arrow-back"></i>
                        <span>Back to Home</span>
                    </Link>

                    <div className="auth__header">
                        <img src={logo} alt="Logo" className="auth__logo" />
                        <h2>Create Your Account</h2>
                        <p>Start your journey with us today</p>
                        {selectedPackage && (
                            <div style={{ marginTop: '1rem', color: 'var(--accent-green)' }}>
                                <i className="bx bx-check-circle"></i> Selected: {selectedPackage.name}
                            </div>
                        )}
                    </div>

                    {error && (
                        <div className="auth__error">
                            <i className="bx bx-error-circle"></i>
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="auth__form">
                        <div className="auth__row">
                            <div className="auth__field">
                                <input
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    placeholder="First Name"
                                    required
                                />
                                <i className="bx bx-user"></i>
                            </div>

                            <div className="auth__field">
                                <input
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    placeholder="Last Name"
                                    required
                                />
                                <i className="bx bx-user"></i>
                            </div>
                        </div>

                        <div className="auth__field">
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Email Address"
                                required
                            />
                            <i className="bx bx-envelope"></i>
                        </div>

                        <div className="auth__row">
                            <div className="auth__field">
                                <input
                                    type="text"
                                    name="company"
                                    value={formData.company}
                                    onChange={handleChange}
                                    placeholder="Company (Optional)"
                                />
                                <i className="bx bx-building"></i>
                            </div>

                            <div className="auth__field">
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="Phone (Optional)"
                                />
                                <i className="bx bx-phone"></i>
                            </div>
                        </div>

                        <div className="auth__field">
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Password (min 8 characters)"
                                required
                                minLength="8"
                            />
                            <i className="bx bx-lock"></i>
                        </div>

                        <div className="auth__field">
                            <input
                                type="password"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                placeholder="Confirm Password"
                                required
                                minLength="8"
                            />
                            <i className="bx bx-lock"></i>
                        </div>

                        <div className="auth__terms">
                            <label>
                                <input
                                    type="checkbox"
                                    name="agreeToTerms"
                                    checked={formData.agreeToTerms}
                                    onChange={handleChange}
                                />
                                <span>
                                    I agree to the <Link to="/terms">Terms of Service</Link> and{' '}
                                    <Link to="/privacy">Privacy Policy</Link>
                                </span>
                            </label>
                        </div>

                        <button type="submit" className="auth__button button button--flex" disabled={loading}>
                            {loading ? (
                                <>
                                    <span className="spinner"></span>
                                    Creating Account...
                                </>
                            ) : (
                                <>
                                    <i className="bx bx-user-plus"></i>
                                    Sign Up
                                </>
                                
                            )}
                        </button>
                    </form>
                  

                    <div className="auth__footer">
                        <p>
                            Already have an account?{' '}
                            <Link to="/login">Sign In</Link>
                        </p>
                    </div>
                </div>

                {/* Side Panel */}
                <div className="auth__side">
                    <h3>Join Our Growing Community</h3>
                    <p>Create your account and unlock powerful features designed to help you manage your projects effectively.</p>
                    
                    <ul className="auth__features">
                        <li>
                            <i className="bx bx-check-circle"></i>
                            <span>Track project progress in real-time</span>
                        </li>
                        <li>
                            <i className="bx bx-check-circle"></i>
                            <span>Secure file sharing and collaboration</span>
                        </li>
                        <li>
                            <i className="bx bx-check-circle"></i>
                            <span>Automated invoicing and payments</span>
                        </li>
                        <li>
                            <i className="bx bx-check-circle"></i>
                            <span>24/7 support and regular updates</span>
                        </li>
                    </ul>

                     <div className="auth__side-note">
                        <i className="bx bx-info-circle"></i>
                        <p>We'll email you a verification link. Confirm it to activate your account and access your dashboard.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;